import React, { ReactNode } from 'react'
import { LoginLayoutRoot, Wrapper, Content } from './LoginLayout.styles'

type LoginLayoutProps = {
  skipOnboarding?: boolean
  children?: ReactNode
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children, skipOnboarding = false }) => {
  return (
    <Wrapper>
      <LoginLayoutRoot gap="0" justifyContent="center" alignItems="center">
        <Content>{children}</Content>
      </LoginLayoutRoot>
    </Wrapper>
  )
}

LoginLayout.displayName = 'LoginLayout'
